import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core';
import PlayArrowRoundedIcon from '@material-ui/icons/PlayArrowRounded';
import PauseRoundedIcon from '@material-ui/icons/PauseRounded';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { useTranslation } from 'react-i18next';
import FlagstoneTheme from '../../../../Config/flagstoneTheme';
import { NavLink } from "react-router-dom";
import { productionOrderStates as state } from '../../../../Config/productionOrderStates'
import Popover from '@material-ui/core/Popover';
import ChangeStatePopoverContent from '../../../Shared/ChangeStatePopoverContent';
import TakeSampleDialog from '../../../Shared/Dialogs/TakeSampleDialog';
import KeyboardArrowRightIcon from '@material-ui/icons/KeyboardArrowRight';
import NewBookingDialog from '../../../Shared/Dialogs/NewBookingDialog';
import FinishOrderDialog from '../../../Shared/Dialogs/FinishOrderDialog'
import StopOrderDialog from '../../../Shared/Dialogs/StopOrderDialog';
import { dataService } from '../../../../Services/data.service'
import { toast } from 'react-toastify';
import Timer from '../../../Shared/Timer';
import { useHistory } from 'react-router-dom';
import AlertDialog from '../../../Shared/Dialogs/AlertDialog';
import ClientCommentsDialog from '../../../Shared/Dialogs/ClientCommentsDialog';
import AddCommentDialog from '../../../Shared/Dialogs/AddCommentDialog';
import { productTypeAdditive, productTypeRawMaterial } from '../../../../Config/constants';
import AddOrderToZonesDrawer from './AddOrderToZonesDrawer';
import { configureZonesByProductionOrderLines } from '../../../../Helpers/OrderInfoHelper';
import CredentialsDialog from '../../../Shared/Dialogs/CredentialsDialog';
import Box from '@mui/material/Box';

export default function OrderDetailStatusBar(props) {

    const classes = useStyles();
    const { t } = useTranslation();
    let history = useHistory();

    const [anchorEl, setAnchorEl] = useState(null);
    const [sampleDialogOpen, setSampleDialogOpen] = useState(false);
    const [newBookingDialogOpen, setNewBookingDialogOpen] = useState(false);
    const [jobCompleteDialogOpen, setJobCompleteDialogOpen] = useState(false)
    const [stopOrderDialogOpen, setStopOrderDialogOpen] = useState(false)
    const [clientCommentsDialogOpen, setClientCommentsDialogOpen] = useState(false)
    const [dialogTitle, setDialogTitle] = useState(null);
    const [dialogContext, setDialogContext] = useState(null);
    const [wrongBarcodeDialogOpen, setWrongBarcodeDialogOpen] = useState(false)
    const [replenishAlertDialogOpen, setReplenishAlertDialogOpen] = useState(false)
    const [addOrderToZonesDialogOpen, setAddOrderToZonesDialogOpen] = useState(false)
    const [credentialsDialogOpen, setCredentialsDialogOpen] = useState(false)
    const [sampleRequiredDialogOpen, setSampleRequiredDialogOpen] = useState(false)
    const [addCommentDialogOpen, setAddCommentDialogOpen] = useState(false)

    const open = Boolean(anchorEl);
    const id = open ? 'simple-popover' : undefined;

    let stateIcon = <React.Fragment></React.Fragment>;
    let stateBackgroundColor = ""

    switch (props.productionOrder.productionOrderStatus) {
        case state.RUNNING:
            stateIcon = <PlayArrowRoundedIcon className={classes.play}></PlayArrowRoundedIcon>;
            stateBackgroundColor = "rgb(92, 201, 88,0.28)"
            break;
        case state.PAUSED:
            stateIcon = <PauseRoundedIcon className={classes.pause} ></PauseRoundedIcon>;
            stateBackgroundColor = "rgb(245, 145, 40,0.28)"
            break;
        case state.STOPPED:
            stateIcon = <div className={classes.stop}></div>;
            stateBackgroundColor = "rgb(216, 73, 73,0.28)"
            break;
        case state.PLANNED:
            stateIcon = <img className={classes.planned} alt="planned" src={process.env.PUBLIC_URL + '/img/planned.svg'}></img>;
            stateBackgroundColor = "rgb(2, 1, 0,0.28)"
            break;
        case state.DONE:
            stateIcon = <img className={classes.done} alt="done" src={process.env.PUBLIC_URL + '/img/done.svg'}></img>;
            stateBackgroundColor = "rgb(92, 201, 88,0.28)"
            break;
        default:
    }

    const checkQuantitiesAtMachineBeforeBookingOrStarting = () => {

        if (getLackingMaterials().length > 0) {
            setDialogTitle(t("Replenish Materials!"));
            setDialogContext(t("Opgelet! Niet genoeg materialen aanwezig. Klik op +Materiaal Toevoegen"));
            setReplenishAlertDialogOpen(true);
            return false;
        }

        return true;
    }

    const getLackingMaterials = () => {

        let lackingMaterials = [];
        var i;
        let bomInNoPackaging = props.productionOrder.bomIn.filter(x => {
            let metaData = JSON.parse(x.bomMetaData);
            return metaData.find(y => y.MetaDataType === 1).MetaData[0].ProductType === productTypeAdditive || metaData.find(y => y.MetaDataType === 1).MetaData[0].ProductType === productTypeRawMaterial;
        })

        for (i = 0; i < bomInNoPackaging.length; i++) {
            let minimumNeededQuantity = (props.productionOrder.bomOut[0].quantityOnCarrier / props.productionOrder.bomOut[0].quantityToProduce) * bomInNoPackaging[i].quantityToConsume;
            let onePalletRemaining = props.producedBOMOut.quantityProduced >= props.productionOrder.bomOut[0].quantityToProduce - props.productionOrder.bomOut[0].quantityOnCarrier;
            if (onePalletRemaining) {
                // Check if last pallet with less quantity is booked
                if (props.producedBOMOut.quantityProduced % props.productionOrder.bomOut[0].quantityOnCarrier === 0) {
                    minimumNeededQuantity = ((props.productionOrder.bomOut[0].quantityToProduce - props.producedBOMOut.quantityProduced) / props.productionOrder.bomOut[0].quantityToProduce) * bomInNoPackaging[i].quantityToConsume;
                }
            }

            if (parseFloat(props.getQuantityAtMachine(bomInNoPackaging[i].productId).toFixed(3)) < parseFloat(minimumNeededQuantity.toFixed(3))) {
                lackingMaterials.push(bomInNoPackaging[i].productId);
            }
        }

        return lackingMaterials;
    }

    const openNewBookingDialog = () => {
        if (checkQuantitiesAtMachineBeforeBookingOrStarting()) {
            setDialogTitle(t("New booking"));
            let totalPallets = Math.ceil(props.productionOrder.bomOut[0].quantityToProduce / props.productionOrder.bomOut[0].quantityOnCarrier);
            let progress = 1;
            if (props.producedBOMOut) {
                progress = Math.ceil(props.producedBOMOut.quantityProduced / props.productionOrder.bomOut[0].quantityOnCarrier) + 1;
            }
            setDialogContext("Pallet " + progress + "/" + totalPallets);
            setNewBookingDialogOpen(true);
        }
    }

    const newBooking = (stackingHeight, paletNumber, selectedZones) => {

        let totalPallets = Math.ceil(props.productionOrder.bomOut[0].quantityToProduce / props.productionOrder.bomOut[0].quantityOnCarrier);
        let progress = 1;
        if (props.producedBOMOut) {
            progress = Math.ceil(props.producedBOMOut.quantityProduced / props.productionOrder.bomOut[0].quantityOnCarrier) + 1;
        }

        let machineId = props.workstation.selectedWorkstation;
        if (selectedZones.length > 0) {

            let usedZones = JSON.parse(props.productionOrder.bowMetaData).find(x => x.MetaDataType === 1).MetaData[0].UsedZones;
            let zonesUpperAndLowerScissor = props.zones.filter(x => x.name === selectedZones[0].zone && x.code.includes(props.productionOrder.machineCode));
            let zone = usedZones.find(x => zonesUpperAndLowerScissor.some(y => y.id === x.ZoneId));
            if (zone) {
                machineId = zone.ZoneId;
            }
        }

        dataService.createBookingForProductionOrder(props.productionOrder, paletNumber, progress, stackingHeight, machineId).then(
            reply => {
                if (checkBookingReply(reply, paletNumber)) {
                    if (progress === totalPallets) {
                        dataService.finishProductionOrderLine(props.productionOrder.orderLineId, props.user.packer).then(

                            setTimeout(() => {
                                props.actions.setSelectedZone(null);
                            }, 1500)).catch((error) => { toast.error(error, { position: "top-center" }) });
                        setDialogTitle(t("Job complete"));
                        setJobCompleteDialogOpen(true);
                    }
                }
                setTimeout(() => { props.refreshOrder(); }, 1500);
            }).catch((error) => { toast.error(error, { position: "top-center" }) });
        setNewBookingDialogOpen(false);
    }

    const changeOrderState = (orderState) => {

        if (orderState === state.STOPPED) {
            setAnchorEl(null)
            setDialogTitle(t("Are you sure to stop?"))
            setDialogContext(t("This can not be made undone!"))
            setStopOrderDialogOpen(true)
        }
        else if (orderState === state.PAUSED) {
            dataService.updateZones(null, props.productionOrder.id, props.productionOrder.machineIdPlanned).then().catch((error) => { toast.error(error, { position: "top-center" }) })
            dataService.pauseProductionOrderLine(props.productionOrder.orderLineId, props.user.packer).then(setTimeout(() => { props.actions.setSelectedZone(null); props.refreshOrder(); }, 2000)).catch((error) => { toast.error(error, { position: "top-center" }) })
            setAnchorEl(null)
        }
        else if (orderState === state.RUNNING) {
            dataService.startProductionOrderLine(props.productionOrder.orderLineId, props.user.packer).then(setTimeout(() => { props.refreshOrder(); }, 2000)).catch((error) => { toast.error(error, { position: "top-center" }) })
            setAnchorEl(null)
        }
    }

    const stopOrder = (permissionGranted) => {
        if ((!props.user.isPloegchef && !props.user.isAdministrator) && !permissionGranted) {
            setCredentialsDialogOpen(true)
            setDialogTitle("ENTER CREDENTIALS")
        }
        else {
            props.actions.setSelectedZone(null)
            dataService.stopProductionOrderLine(props.productionOrder.orderLineId, props.productionOrder.machineId, null, null, props.user.packer).then(setTimeout(() => { props.refreshOrder(); }, 2000)).catch((error) => { toast.error(error, { position: "top-center" }) })
        }
    }

    const checkBookingReply = (reply, barcode) => {
        if (!reply.succeeded && reply.messages[0].includes('Error2')) {
            setDialogTitle(t("Wrong barcode!"))
            setDialogContext(t("Given barcode ") + barcode + t(" is not assigned to production order ") + props.productionOrder.reference)
            setWrongBarcodeDialogOpen(true)
            return false
        }
        else if (!reply.succeeded && reply.messages[0].includes('Error3')) {
            setDialogTitle(t("Pallet already booked!"))
            setDialogContext(t("Pallet with barcode ") + barcode + t(" is already booked for production order ") + props.productionOrder.reference)
            setWrongBarcodeDialogOpen(true)
            return false
        }
        else if (!reply.succeeded && reply.messages[0].includes('Error4')) {
            setDialogTitle(t("No samples taken!"))
            setDialogContext(t("Pallet with barcode ") + barcode + t(" heeft nog geen staalnames, gelieve eerst een steekproef te nemen voordat u boekt."))
            setSampleRequiredDialogOpen(true)
            return false
        }

        return true
    }

    const handleClose = () => {
        setAnchorEl(null);
    };

    const openPopover = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const openTakeSampleDialog = () => {
        setSampleRequiredDialogOpen(false)
        takeSample()
    }

    const takeSample = () => {
        setDialogTitle(t("Take a sample") + "!")
        if (props.workstation.selectedZone) {
            setDialogContext(t("PLATE measurement from LINE ") + props.productionOrder.machinePlannedCode + " zone " + props.workstation.selectedZone)
        }
        else {
            setDialogContext(t("PLATE measurement from LINE ") + props.productionOrder.machinePlannedCode)
        }

        setSampleDialogOpen(true)
    };

    const openAddOrderToZonesDialog = (open) => {
        setAddOrderToZonesDialogOpen(open);
    }

    const closeSampleDialog = () => {
        setSampleDialogOpen(false)
    }

    const closeCredentialsDialog = () => {
        setCredentialsDialogOpen(false)
    }

    const handleAddComment = (comment) => {
        console.log('Comment submitted:', comment);

        // Save to backend using the new API endpoint
        dataService.addOperatorCommentToOrderlineMetaData(
            props.productionOrder.orderLineId,
            comment,
            props.user.id
        ).then(() => {
            toast.success('Notitie succesvol opgeslagen', { position: "top-center" });
            setTimeout(() => { props.refreshOrder(); }, 1000);
        }).catch((error) => {
            toast.error('Fout bij opslaan notitie: ' + error, { position: "top-center" });
        });

        setAddCommentDialogOpen(false);
    }

    const performTest = (palletnumber, progress, selectedZones) => {
        let machineId = props.workstation.selectedWorkstation
        if (selectedZones.length > 0) {
            let usedZones = JSON.parse(props.productionOrder.bowMetaData).find(x => x.MetaDataType === 1).MetaData[0].UsedZones
            let zonesUpperAndLowerScissor = props.zones.filter(x => x.name === selectedZones[0].zone && x.code.includes(props.productionOrder.machineCode))
            let zone = usedZones.find(x => zonesUpperAndLowerScissor.some(y => y.id === x.ZoneId))
            if (zone) {
                machineId = zone.ZoneId
            }
        }

        history.push('/sampling/' + props.productionOrder.id + '/' + palletnumber + "/" + progress + "/0/" + machineId + "/detail/" + props.productionOrder.orderLineId)
    };

    let pausedOrRunning = props.productionOrder.productionOrderStatus === state.RUNNING || props.productionOrder.productionOrderStatus === state.PAUSED;
    // let doneOrStopped = props.productionOrder.productionOrderStatus === state.DONE || props.productionOrder.productionOrderStatus === state.STOPPED
    let planned = props.productionOrder.productionOrderStatus === state.PLANNED;
    let paused = props.productionOrder.productionOrderStatus === state.PAUSED;
    let running = props.productionOrder.productionOrderStatus === state.RUNNING;
    let piecesPerPallet = props.productionOrder.bomOut[0].quantityOnCarrier;
    let authorized = props.productionOrder.machineIdPlanned === props.workstation.selectedWorkstation;
    let progress = 0;
    let comments = "";
    if (props.productionOrder) {
        comments = JSON.parse(props.productionOrder.metaData).find(y => y.MetaDataType === 2).MetaData[0].ClientComments;
    }

    if (props.producedBOMOut) {
        progress = Math.ceil(props.producedBOMOut.quantityProduced / props.productionOrder.bomOut[0].quantityOnCarrier);
    }

    let zones = configureZonesByProductionOrderLines(props.productionOrders, props.zones);

    return <React.Fragment>
        <div className={classes.stateContainer} style={{ backgroundColor: stateBackgroundColor }}>
            <button className={classes.popoverButton} onClick={running && authorized ? (e) => openPopover(e) : planned && authorized || paused && authorized ? () => openAddOrderToZonesDialog(true) : null} style={{ cursor: ((pausedOrRunning || planned) && authorized) && "pointer" }}>
                <div className={classes.centerState}>
                    <div className={classes.icon}>{stateIcon}</div>
                    <div className={classes.stateElapsed} >
                        <div className={classes.state} style={{ marginTop: pausedOrRunning ? "0px" : props.productionOrder.productionOrderStatus === state.STOPPED ? "4px" : "6px" }}>{t(props.productionOrder.productionOrderStatus)}</div>
                        {pausedOrRunning ? <div className={classes.elapsed}><Timer startTime={props.productionOrder.startedOn} paused={paused} {...props}></Timer></div> : <React.Fragment></React.Fragment>}
                    </div>
                    {pausedOrRunning && authorized ? <ExpandMoreIcon className={classes.expandStatesIcon}></ExpandMoreIcon> : planned && authorized ? <KeyboardArrowRightIcon className={classes.expandStatesIcon}></KeyboardArrowRightIcon> : <React.Fragment></React.Fragment>}
                </div>
            </button>
        </div>
        {props.productionOrder.productionOrderStatus === state.DONE || props.productionOrder.productionOrderStatus === state.STOPPED || props.productionOrder.productionOrderStatus === state.PLANNED || !authorized ? <React.Fragment></React.Fragment> : <div className={classes.newBooking}>
            <button className={classes.newBookingButton} onClick={() => openNewBookingDialog()}>
                <div className={classes.newBookingText} >{t('NEW BOOKING')}</div>
            </button>
        </div>}
        {!planned && authorized ? <div className={classes.actions}>
            <div className={classes.action}>
                <button className={classes.actionButton} onClick={() => takeSample()}>
                    <Box sx={{
                        display: 'flex', fontSize: { xs: '1.4cqw', md: '14px' },
                        fontFamily: "Lato, sans-serif",
                        fontWeight: 'bold',
                    }} className={classes.actionText}>
                        {t('TakeASample')}
                    </Box>
                </button>
            </div>
            <div className={classes.action}>
                <NavLink className={classes.navButton} to={`/qualitychecks/${progress}/${encodeURIComponent(props.productionOrder.id)}/${encodeURIComponent(props.productionOrder.orderLineId)}`}>
                    <button className={classes.actionButton}>
                        <Box sx={{
                            display: 'flex', fontSize: { xs: '1.4cqw', md: '14px' },
                            fontFamily: "Lato, sans-serif",
                            fontWeight: 'bold',
                        }} className={classes.actionText}>
                            {t('QualityChecks')}
                        </Box>
                    </button>
                </NavLink>
            </div>
            {pausedOrRunning && authorized ?
                <div className={classes.action}>
                    <button className={classes.actionButton} onClick={() => props.openMachineParametersDrawer(true)}>
                        <Box sx={{
                            display: 'flex', fontSize: { xs: '1.4cqw', md: '14px' },
                            fontFamily: "Lato, sans-serif",
                            fontWeight: 'bold',
                        }} className={classes.actionText}>
                            {t('MachineParameters')}
                        </Box>
                    </button>
                </div>
                : <React.Fragment></React.Fragment>}
            {
                (props.productionOrder.productionOrderStatus == state.DONE || props.productionOrder.productionOrderStatus == state.STOPPED) ?
                    <div className={classes.action}>
                        <button className={classes.actionButton} onClick={() => props.openZoneDivisionPopup(true)}>
                            <Box sx={{
                                display: 'flex', fontSize: { xs: '1.4cqw', md: '14px' },
                                fontFamily: "Lato, sans-serif",
                                fontWeight: 'bold',
                            }} className={classes.actionText}>
                                {t('Zonale verdeling')}
                                {
                                    props.hasZoneDivisions && <div className={classes.zonesDone}><img className={classes.doneIcon} alt="done" src={process.env.PUBLIC_URL + '/img/done.svg'}></img></div>
                                }
                            </Box>
                        </button>
                    </div> :
                    <div className={classes.action}>
                        <button className={classes.actionButton} onClick={() => props.openZoneDivisionPopupInput(true)}>
                            <Box sx={{
                                display: 'flex', fontSize: { xs: '1.4cqw', md: '14px' },
                                fontFamily: "Lato, sans-serif",
                                fontWeight: 'bold',
                            }} className={classes.actionText}>
                                {t('Zonale verdeling')}
                                {
                                    props.hasZoneDivisions && <div className={classes.zonesDone}><img className={classes.doneIcon} alt="done" src={process.env.PUBLIC_URL + '/img/done.svg'}></img></div>
                                }
                            </Box>
                        </button>
                    </div>
            }
            <div className={classes.action}>
                <NavLink className={classes.navButton} to={`/productionstate/${encodeURIComponent(props.productionOrder.id)}/${encodeURIComponent(props.productionOrder.machineId)}/${encodeURIComponent(props.productionOrder.orderLineId)}`}>
                    <button className={classes.actionButton}>
                        <Box sx={{
                            display: 'flex', fontSize: { xs: '1.4cqw', md: '14px' },
                            fontFamily: "Lato, sans-serif",
                            fontWeight: 'bold',
                        }} className={classes.actionText}>
                            {t('Productionstate')}
                        </Box>
                    </button>
                </NavLink>
            </div>
            <div className={classes.action}>
                <button className={classes.actionButton} onClick={() => setAddCommentDialogOpen(true)}>
                    <Box sx={{
                        display: 'flex', fontSize: { xs: '1.4cqw', md: '14px' },
                        fontFamily: "Lato, sans-serif",
                        fontWeight: 'bold',
                    }} className={classes.actionText}>
                        {t('Notitie toevoegen')}
                    </Box>
                </button>
            </div>
            <div className={classes.actionWarn}>
                <button className={classes.actionButton} onClick={() => props.openStandstillPopup(true)}>
                    <Box sx={{
                        display: 'flex', fontSize: { xs: '1.4cqw', md: '14px' },
                        fontFamily: "Lato, sans-serif",
                        fontWeight: 'bold',
                    }} className={classes.actionWarnText}>
                        {t('Stilstand')}
                    </Box>
                </button>
            </div>
            

        </div>
            :
            <React.Fragment></React.Fragment>}
        {comments === "" || comments === null ?
            <React.Fragment></React.Fragment>
            :
            <div className={classes.clientCommentsContainer} style={{ height: pausedOrRunning ? "59%" : planned ? "87%" : "72%" }}>
                <div className={classes.clientCommentsTitle}>
                    {t("Client comments")}
                </div>
                <div className={classes.clientComments}>
                    {comments.length > 400 ? <div dangerouslySetInnerHTML={{ __html: comments.substring(0, 400) }}/>
                        : <div dangerouslySetInnerHTML={{ __html: comments }}/>
                        }
                </div>
                {comments.length > 400 ?
                    <div className={classes.showMoreButtonContainer}>
                        <button className={classes.showMoreButton} onClick={() => setClientCommentsDialogOpen(true)}>
                            {t("SHOW MORE")}
                        </button>
                    </div>

                    :
                    <React.Fragment></React.Fragment>}
            </div>}
        <Popover
            id={id}
            open={open}
            anchorEl={anchorEl}
            onClose={handleClose}
            anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'center',
            }}
            transformOrigin={{
                vertical: 'top',
                horizontal: 'center',
            }}
        >
            <ChangeStatePopoverContent state={props.productionOrder.productionOrderStatus} changeState={changeOrderState}></ChangeStatePopoverContent>
        </Popover>
        <AlertDialog dialogOpen={replenishAlertDialogOpen} dialogTitle={dialogTitle} dialogContext={dialogContext} closeDialog={() => setReplenishAlertDialogOpen(false)} action={() => setReplenishAlertDialogOpen(false)}></AlertDialog>
        <AlertDialog dialogOpen={sampleRequiredDialogOpen} dialogTitle={dialogTitle} dialogContext={dialogContext} closeDialog={() => setSampleRequiredDialogOpen(false)} action={() => setSampleRequiredDialogOpen(false)} action2={() => openTakeSampleDialog()} secondActionName={"Take a sample"}></AlertDialog>
        <AlertDialog dialogOpen={wrongBarcodeDialogOpen} dialogTitle={dialogTitle} dialogContext={dialogContext} closeDialog={() => setWrongBarcodeDialogOpen(false)} action={() => setWrongBarcodeDialogOpen(false)}></AlertDialog>
        <FinishOrderDialog {...props} producedBOMOut={props.producedBOMOut} dialogOpen={jobCompleteDialogOpen} action={() => setJobCompleteDialogOpen(false)} dialogTitle={dialogTitle} dialogContext={dialogContext} piecesPerPallet={piecesPerPallet} closeDialog={() => setJobCompleteDialogOpen(false)}></FinishOrderDialog>
        <NewBookingDialog  {...props} productionOrder={props.productionOrder} dialogOpen={newBookingDialogOpen} action={newBooking} zonesWithScissors={zones} closeDialog={() => setNewBookingDialogOpen(false)} dialogTitle={dialogTitle} dialogContext={dialogContext}></NewBookingDialog>
        <CredentialsDialog dialogTitle={dialogTitle} dialogContext={dialogContext} dialogOpen={credentialsDialogOpen} closeDialog={closeCredentialsDialog} action={stopOrder}> </CredentialsDialog>
        <StopOrderDialog {...props} producedBOMOut={props.producedBOMOut} dialogOpen={stopOrderDialogOpen} action={stopOrder} dialogTitle={dialogTitle} dialogContext={dialogContext} piecesPerPallet={piecesPerPallet} closeDialog={() => setStopOrderDialogOpen(false)} ></StopOrderDialog>
        <AddOrderToZonesDrawer openDrawer={openAddOrderToZonesDialog} zones={props.zones} zonesWithScissors={zones} drawerOpen={addOrderToZonesDialogOpen} {...props} actions={props.actions} productionOrder={props.productionOrder} productionOrders={props.productionOrders} refreshOrder={props.refreshOrder} checkQuantitiesAtMachineBeforeBookingOrStarting={checkQuantitiesAtMachineBeforeBookingOrStarting}></AddOrderToZonesDrawer>
        <ClientCommentsDialog {...props} comments={comments} dialogOpen={clientCommentsDialogOpen} closeDialog={() => setClientCommentsDialogOpen(false)}></ClientCommentsDialog>
        <TakeSampleDialog {...props} productionOrder={props.productionOrder} progress={progress} closeDialog={() => closeSampleDialog()} zonesWithScissors={zones} dialogOpen={sampleDialogOpen} action={performTest} dialogTitle={dialogTitle} dialogContext={dialogContext} piecesPerPallet={piecesPerPallet}></TakeSampleDialog>
        <AddCommentDialog 
            dialogOpen={addCommentDialogOpen} 
            closeDialog={() => setAddCommentDialogOpen(false)} 
            onSubmit={handleAddComment}
            orderLineId={props.productionOrder.orderLineId}
        />
    </React.Fragment>
}

const useStyles = makeStyles({
    play: {
        color: "#5CC958",
        height: "50px",
        width: "50px"
    },
    stop: {
        height: "25px",
        width: "25px",
        backgroundColor: "#D84949",
        borderRadius: "3px",
        margin: "10px",
        marginTop: "8px"
    },
    pause: {
        height: "45px",
        width: "45px",
        color: "#F59127",
        marginLeft: "5px"
    },
    planned: {
        height: "35px",
        width: "35px",
        marginTop: "5px",
        marginRight: "10px"
    },

    cancel: {
        margin: "10px",
        marginTop: "8px",
        marginLeft: "12px"
    },
    icon: {
        float: "left",
    },
    state: {
        textTransform: "uppercase",
        fontSize: "17px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'bold',
        color: "#020100",
        display: "block"
    },
    stateElapsed: {
        float: "left",
        marginLeft: "5px",
        marginTop: "5px"
    },
    elapsed: {
        fontSize: "12px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'medium',
        color: "#8D8D8D",
        display: "block"
    },
    centerState: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: "center",
        justifyContent: "center",
        flexWrap: "wrap",
        overflow: "hidden",
        height: "100%",
        width: "100%",
        paddingTop: "10px",
        paddingBottom: "10px"
    },
    stateContainer: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: "center",
        overflow: "hidden",
        justifyContent: 'center',
        height: '100%'
    },
    changeButton: {
        width: "86%",
        marginTop: "15px",
        marginLeft: "7%",
        marginRight: "7%",
        height: "40px",
        borderRadius: "6px",
        padding: "0px",
        border: "none",
        outline: "none",
        cursor: "pointer",
    },
    changePlay: {
        color: "white",
    },
    changePause: {
        color: "white",
    },
    changeText: {
        color: "white",
        float: "left",
        fontSize: "14px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'medium',
        padding: "5px",
        paddingTop: "8px"
    },
    changeArrow: {
        float: "right",
    },
    expandStatesIcon: {
        float: "left",
        marginTop: "10px",
        marginLeft: "10px",
        color: FlagstoneTheme.palette.primary.main
    },
    changeIcon: {
        float: "right",
        padding: "5px",
        paddingRight: "0px"
    },
    changeArrowIcon: {
        paddingTop: "5px",
        paddingRight: "5px",
        height: "25px",
        width: "25px",
        fill: "white"
    },
    navButton: {
        textDecoration: 'none !important'
    },
    newBookingButton: {
        width: "86%",
        marginTop: "20px",
        marginLeft: "7%",
        marginRight: "7%",
        marginBottom: "10px",
        height: "40px",
        borderRadius: "6px",
        padding: "0px",
        backgroundColor: FlagstoneTheme.palette.primary.main,
        border: "none",
        outline: "none",
        cursor: "pointer",
    },
    newBookingText: {
        color: "white",
        fontSize: "14px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'medium',
        padding: "5px",
    },
    actions: {
        width: "100%",
        height: "auto",
        padding: "7%",
        paddingTop: "20px",
        boxSizing: "border-box"
    },
    action: {
        backgroundColor: "#4654FB22",
        height: "40px",
        widht: "100%",
        borderRadius: "5px",
        marginBottom: "5px",
    },
    actionWarn: {
        backgroundColor: "rgba(245, 145, 39, 0.1)",
        height: "40px",
        widht: "100%",
        borderRadius: "5px",
        marginBottom: "5px",
    },
    actionText: {
        float: "left",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'bold',
        color: FlagstoneTheme.palette.primary.main,
        textTransform: "none",
        width: "100%",
        textAlign: "center",
        display: "flex",
        flexDirection: "row",
        justifyContent: "center"
    },
    actionWarnText: {
        float: "left",
        fontSize: "14px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'bold',
        color: "Orange",
        textTransform: "none",
        width: "100%",
        textAlign: "center",
        display: "flex",
        flexDirection: "row",
        justifyContent: "center"
    },
    actionButton: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        width: "100%",
        height: "100%",
        border: "none",
        outline: "none",
        cursor: "pointer",
        backgroundColor: "transparent",
    },
    popoverButton: {
        border: "none",
        outline: "none",
        backgroundColor: "rgba(1,1,1,0)"
    },
    clientCommentsContainer: {
        backgroundColor: "#FFF8DB",
        width: "100%",
        padding: "7%",
        boxSizing: 'border-box'
    },
    clientCommentsTitle: {
        fontSize: "16px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'bold',
    },
    clientComments: {
        fontSize: "14px",
        fontFamily: "Lato, sans-serif",
        marginTop: "7%"
    },
    showMoreButtonContainer: {
        width: "100%",
        textAlign: "center"
    },
    showMoreButton: {
        width: "120px",
        height: "40px",
        fontSize: "16px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'bold',
        color: FlagstoneTheme.palette.primary.main,
        backgroundColor: "#FFF8DB",
        cursor: "pointer",
        border: "none",
        outline: "none",
        marginTop: "20px"
    },
    zonesDone: {
        float: "right",
        width: "15px",
        height: "15px",
        marginLeft: "10px",
        display: "flex",
        flexDirection: "column"
    },
    done: {
        height: "25px",
        width: "25px",
        margin: "10px",
        marginTop: "8px"

    },
    doneIcon: {
        height: "25px",
        width: "25px",
    }
});